<div class="table-container" *ngIf="dataBlocks && dataBlocks.length; else noData">
    <aside class="locked">
        <table>
            <thead>
                <tr>
                    <th> </th>
                    <th> </th>
                    <th *ngFor="let label of dataBlocks[0].specialLabels" class="special">
                        {{ label }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let data of dataBlocks">
                    <tr *ngFor="let row of data.rows; index as i">
                        <td *ngIf="i === 0" [attr.rowspan]="data.rows.length" class="block-name">
                            {{ data.text.shortLabel }}
                        </td>
                        <td>{{ row.text.shortLabel }}</td>

                        <td *ngFor="let label of data.specialLabels; index as i"
                            [ngClass]="{special: row.specialColumns && row.specialColumns[i]}">
                            <span *ngIf="row.specialColumns && row.specialColumns[i]">
                                {{ row.specialColumns[i].value | formatAmount }}
                            </span>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </aside>

    <section class="years-data">
        <table>
            <thead>
                <tr>
                    <th *ngFor="let label of dataBlocks[0].columnsLabels">
                        {{ label }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let data of dataBlocks">
                    <tr *ngFor="let row of data.rows">
                        <td *ngFor="let column of row.columns">
                            {{ column.value | formatAmount }}
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </section>
</div>
<ng-template #noData>
    <p>{{'invest.eval.noData.summary' | translate}}</p>
</ng-template>
